import React, { useState, useEffect } from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { postAPI, displayMessage, makeFileURL } from "../../utils/common";
import { LOGIN } from "../../constants/api";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import assets from "../../utils/ImagesPath";
import "../../assets/css/Login.css";
import LS_SERVICE from "../../utils/localStorage";

function Login() {
  const [loading, setLoading] = useState(false);
  const [time, setTime] = useState("");
  const [date, setDate] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  const logo = assets.logo;
  const images = assets.backgrounds;

  useEffect(() => {
    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(changeBackgroundImage, 5000);
    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  const updateClock = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    setTime(`${hours}:${minutes}`);
    const options = { year: "numeric", month: "long", day: "numeric" };
    setDate(now.toLocaleDateString(undefined, options));
  };

  const changeBackgroundImage = () => {
    setVisible(false);
    setTimeout(() => {
      setCurrentIndex((currentIndex + 1) % images.length);
      setVisible(true);
    }, 1000); // 1 second fade-out
  };

  const onFinish = (values) => {
    setLoading(true);
    const data = new FormData();
    const username = values.username;

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const mobileRegex = /^[0-9]{10}$/;
    if (emailRegex.test(username)) {
      data.append("email", username);
    } else if (mobileRegex.test(username)) {
      data.append("mobile", username);
    } else {
      return displayMessage(
        ERROR_MSG_TYPE,
        "Fail to Invalid email or mobile number"
      );
    }

    data.append("password", values.password);
    const successFn = function (data) {
      if (data["status"] === true) {
        LS_SERVICE.set("id", data["user"]["id"]);
        LS_SERVICE.set("name", data["user"]["name"]);
        LS_SERVICE.set(
          "profile",
          data["user"]["image"] && data["user"]["image"]["filePath"]
            ? data["user"]["image"]["filePath"]
            : ""
        );
        LS_SERVICE.set("user_type", data["user"]["user_type"]);
        LS_SERVICE.set("phone", data["user"]["mobile"]);
        LS_SERVICE.set("email", data["user"]["email"]);
        LS_SERVICE.set("token", data["token"]);
        setLoading(false);
        displayMessage(SUCCESS_MESSAGE, data["message"]);
        window.location.reload();
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data["message"]);
      }
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Fail to Login");
    };
    postAPI(LOGIN, data, successFn, errorFn);
  };
  return (
    <>
      <div
        className={`slider ${visible ? "visible" : ""}`}
        style={{ backgroundImage: `url(${images[currentIndex]})` }}
      ></div>
      <div className="header-container">
        <div className="login-logo">
          <img
            src={
              LS_SERVICE.get("setting")
                ? `${makeFileURL(LS_SERVICE.get("setting")["logo"])}`
                : logo
            }
            alt="Logo"
          />
        </div>
        <div className="clock">
          <p className="time">{time}</p>
          <p className="date">{date}</p>
        </div>
      </div>
      <div className="login-container">
        <div className="login-content">
          <h3>
            <b>Please Enter the Credentials to Login</b>
          </h3>
          <Form
            name="login"
            onFinish={onFinish}
            layout="vertical"
            className="login-form"
          >
            <Row gutter={16}>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your phone/email!",
                    },
                  ]}
                >
                  <Input className="input" placeholder="Enter Phone/Email" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please enter your password!" },
                  ]}
                >
                  <Input.Password
                    className="input"
                    placeholder="Enter Password"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-btn"
                loading={loading}
              >
                Login
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
}

export default Login;
